// eslint-disable-next-line import/prefer-default-export
export const DEPOSIT_MINIMUM_AMOUNT = 200;
export const DEPOSIT_MAXIMUM_AMOUNT = 50000;
